import React, {useContext} from 'react';
import {BrowserRouter as Router} from 'react-router-dom'
import {Switch, Route} from 'react-router-dom'
import {AppContextProvider} from './App/context/appContext'
import {SettingsContextProvider} from './App/context/settingsContext'
import {MappingsContextProvider} from './App/context/mappingsContext'
import {MessagesContextProvider} from './App/context/messagesContext'

import Messages from './App/pages/Messages'
import Settings from "./App/pages/Settings"
import Mappings from "./App/pages/Mappings"

const App = ({jwt, message, initSearch}) => {
  return (
    <div className='App'>
      <AppContextProvider token={jwt} >
        <Router>
          <Switch>
            <Route exact path="/">
              <MessagesContextProvider>
                <Messages message={message} initSearch={initSearch} />
              </MessagesContextProvider>
            </Route>
            <Route exact path="/settings">
              <SettingsContextProvider>
                <Settings />
              </SettingsContextProvider>
            </Route>
            <Route path="/mappings/:objectId">
              <MappingsContextProvider>
                <Mappings />
              </MappingsContextProvider>
            </Route>
          </Switch>
        </Router>
      </AppContextProvider>
    </div>
  )
}

export default App
